import { log } from 'log';
import { useCallback } from 'react';

import * as Types from '../types';
import { useUserSelector } from 'js/store/hooks';
import { path } from 'ramda';
import { htcmdService } from 'js/services/htcmd.service';
import { validateGeolocation } from 'js/hooks/auth/pas';

export const useRequestXpointNativePacket = ({
    sdk,
    transactionID,
    geolocationType
}: {
    sdk: Types.XPointSDKInstance | null;
    transactionID: string | null;
    geolocationType: string;
}) => {
    const userId: string = useUserSelector(path(['userDetails', 'userId'])) ?? '';

    return useCallback(async () => {
        if (!sdk || !transactionID) {
            return;
        }

        const response = await validateGeolocation(null, null, null, null, null, geolocationType);
        const sessionValidationData = response.data.sessionValidationData || {};
        const sessionValidationByGeolocationData = sessionValidationData.SessionValidationByGeolocationData || [];
        const geolocationData = sessionValidationByGeolocationData[0] || {};
        const {
            clientId,
            clientBrand,
            jurisdictionAreaId,
            jurisdictionAreaName,
            customData,
            sessionHash
        } = Object.fromEntries(geolocationData.properties?.map(({
            key,
            value
        }: {
            key: string;
            value: string;
        }) => {
            return [key, value];
        }) ?? []);

        log('gcReq', {
            transactionID
        });

        htcmdService.sendMessage('geofencingrequest', {
            provider: 'xpoint',
            transactionID,
            userId,
            clientId,
            clientBrand,
            jurisdictionAreaId,
            jurisdictionAreaName,
            customData,
            sessionHash
        });
    }, [
        sdk,
        userId,
        transactionID,
        geolocationType
    ]);
};
